import { getExperienceId } from "@swa-ui/application";
import { logger } from "@swa-ui/log";

import { getApiKey } from "../getApiKey";
import { getChannelId } from "../getChannelId";

export function initLogger(appId, persona) {
  const apiKey = getApiKey();
  const channelId = getChannelId(persona);
  const experienceId = getExperienceId();

  logger.init({ apiKey, appId, channelId, experienceId });
}
